import { injectGlobal, keyframes } from 'emotion';
import { carousel } from './carousel.styles';
import { flipCard } from './flipCard.styles';
import isIE from 'services/isIE';
import { focusBorder, focusBoxShadow } from './variables';

const fader = keyframes`
from {
	opacity: 0;
}
to {
	opacity: 1;
}
`;

injectGlobal`

	* {
		margin: 0;
		padding: 0;
		box-sizing: border-box;

		&::-webkit-scrollbar {
			width: 5px;
		}
		
		&::-webkit-scrollbar-track {
			background-color: lightgrey;
		}
		
		&::-webkit-scrollbar-thumb {
			background-color: darkgrey;
		}

		-webkit-tap-highlight-color: transparent;

	}
	
	html, body {
		width: 100%;
		height: 100%;
	}

	body {
		font-family: 'Poppins', sans-serif;
		font-weight: 300;
		overflow-anchor: none;
	}

	h1, h2, h3, h4 {
		// margin: 10px 0;
		font-weight: 200;
		line-height: 1.2em;

		// ul, li {
		// 	margin-left: 0;
		// 	font-size: 16px;
		// }
	}

	h1 {
			font-size: 2rem;
	}

	h2 {
			font-size: 1.5rem;
	}

	h3 {
			font-size: 1.3rem;
	}

	h4 {
			font-size: 1rem;
	}


	@media(min-width: 480px) {
			h1 {
					font-size: 2.5rem;
			}

			h2 {
					font-size: 2rem;
			}

			h3 {
					font-size: 1.8rem;
			}

			h4 {
					font-size: 1.5rem;
			}
	}

	@media(min-width: 767px) {
			h1 {
					font-size: 3.5rem;
			}

			h2 {
					font-size: 2.5rem;
			}

			h3 {
					font-size: 2rem;
			}

			h4 {
					font-size: 1.2rem;
			}
	}


	// p {
	// 	margin-bottom: 15px;
	// }

	// p:last-child {
	// 	margin-bottom: 0px;
	// }

	div, p, span {
		line-height: 1.2em;
	}

	p strong {
		font-weight: 700 !important;
	}

	strong {
		font-weight: 700 !important;
	}
	
	// margin: 0 0 15px 15px;
	ul {
		margin: 0 0 0 20px;
		${isIE() &&
      `
		margin: 0 0 0 13px;
		padding: 0 15px 0 0;
		`}

		list-style-type: disc;
	}

	ol {
		margin: 0 0 0 22px;

	
	}

	ul, ol, li {
		line-height: 1.2em;
	}

	input[type=text] {
		font-weight: 300;
	}

	img {
		align-self: center;
		vertical-align: bottom;
		max-width: 100%;
		flex-shrink: 0;
	}

	// svg {
	// 	max-height: 50vh !important;
	// }

	form {
		width: 100%;
	}

	#root {
		width: 100%;
		height: 100%;
	}

	.chameleon-text {
		width: 100%;

		overflow-wrap: break-word;
		word-wrap: break-word;
		
		// return to this and play with values
		// test in ie where weird things will happen
  	// -ms-word-break: break-all;
 		// white-space: pre-wrap;

		word-break: break-word;

		p {
			
		line-height: 1.5em;

		}
	}

	h1, h2, h3, h4 {

		li {
			margin-left: .5em;
		}

		ol {
			position: relative;
			left: .5em;
		}

		ol li:before {
	
			padding-left: 10px !important;
		}

	}



	.fader_-2s {
		animation: ${fader} 0.2s forwards;
	}

	.fader_-5s {
		animation: ${fader} 0.5s forwards;
	}

	.fader_1s {
		animation: ${fader} 1s forwards;
	}

	button {
		font-family: inherit !important;

		// :focus {
		// 	box-shadow: ${focusBoxShadow};
		// }

	}

	input {
		:focus {
			border: ${focusBorder};
		}
	}

	textarea {
		:focus {
			border: ${focusBorder};
		}
	}

	// ${carousel}
	${flipCard}

	pre {
		display: flex;
		// padding: 10px 10px 20px 10px !important;

		padding: 0 !important;
		border: none !important;
		// border-radius: 3px;
		
	}

	code {
		display: inline;
		padding: 10px 20px 20px 10px !important;
		border-radius: 3px;
		background: #eaeffb;
	}

	*:focus {
		outline: none;
	}

	a:focus {
		text-decoration: none;
		opacity: 0.45;
	}

	.center-text {
		text-align: center;
	}

	// https://gist.github.com/ffoodd/000b59f431e3e64e4ce1a24d5bb36034
	.sr-only {
		border: 0 !important;
		clip: rect(1px, 1px, 1px, 1px) !important; 
		-webkit-clip-path: inset(50%) !important;
			clip-path: inset(50%) !important;  
		height: 1px !important;
		margin: -1px !important;
		overflow: hidden !important;
		padding: 0 !important;
		position: absolute !important;
		width: 1px !important;
		white-space: nowrap !important;            
	}

`;
